module.exports = __webpack_public_path__ + "static/media/sec-2-back-img-1.c8663320.png";